import { Modal, Button } from "react-bootstrap";

function DeviceModal({ show, onClose, device }) {
  if (!device) return null;

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  const renderValue = (value) => value || <span className="text-muted">-</span>;

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Device {device.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <table className="table">
          <tbody>
            <tr style={getRowStyle(0)}>
              <th style={{ width: "140px" }}>Name</th>
              <td>{renderValue(device.name)}</td>
            </tr>
            <tr style={getRowStyle(1)}>
              <th>Note</th>
              <td style={{ whiteSpace: "pre-wrap" }}>{renderValue(device.note)}</td>
            </tr>
            <tr style={getRowStyle(2)}>
              <th>User</th>
              <td>{renderValue(device.User?.name)}</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeviceModal;
